// src/confluence/comment/types.ts
var ConfluenceCommentAriResourceOwner = "confluence", ConfluenceCommentAriResourceType = "comment";

export {
  ConfluenceCommentAriResourceOwner,
  ConfluenceCommentAriResourceType
};
